import React, { useRef } from "react";
import Lottie from "lottie-react";
import loader from "../../assets/animations/loading.json";

function Loading({ title, size = 160, fullScreen = false }) {
  const loaderRef = useRef();

  // Allow numeric or string size, and make it responsive by default
  const resolvedSize =
    typeof size === "number" ? `${size}px` : size || "50vw";

  return (
    <div
      className="w-100 d-flex justify-content-center"
      style={
        fullScreen
          ? {
              minHeight: "100vh",
              alignItems: "center",
              padding: "1rem",
            }
          : { padding: "1rem" }
      }
    >
      <div className="rounded-4 w-100" style={{ maxWidth: 480 }}>
        <div
          className="w-100 d-flex justify-content-center align-items-center"
          style={{
            width: "100%",
            maxWidth: resolvedSize,
            height: "auto",
            aspectRatio: "1 / 1",
          }}
        >
          <Lottie
            lottieRef={loaderRef}
            animationData={loader}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        {title && (
          <div
            className="w-100 d-flex justify-content-center"
            style={{
              userSelect: "none",
              color: "black",
              fontSize: 16,
              fontWeight: "600",
              marginTop: "0.75rem",
              textAlign: "center",
            }}
          >
            {title}
          </div>
        )}
      </div>
    </div>
  );
}

export default Loading;
